
import { Vue, Component, Prop } from "vue-property-decorator";
import LIST_DIRECTORY from "@/apollo/directory/ListDirectory.gql";

import AngleIcon from "@/components/icons/AngleIconNew.vue";
import NavigationIcon from "@/components/common/NavigationIcon.vue";
import ShareUrlButton from "@/components/common/ShareUrlButton.vue";

import Breadcrumb from "@/entities/Breadcrumb";
import NavigationIcons from "@/entities/NavigationIcons";
import Badge from "@/components/common/Badge.vue";
import { Contractor, User } from "@/generated/graphql";

import { ApolloQueryResult } from "apollo-client";
import { gql } from "graphql-tag";

@Component({
  components: {
    AngleIcon,
    NavigationIcon,
    ShareUrlButton,
    Badge,
  },
  apollo: {
    contractors: {
      query: LIST_DIRECTORY,
      variables() {
        return this.directoryFilter;
      },
      skip() {
        return this.skipQuery;
      },
      update(data) {
        this.paginationConfig.total = data.total.aggregate.count;
        this.paginationConfig.loadedCount = data.contractor.length;
        this.totalElements = data.contractor.length;
        this.$emit("contractorsTotalChanged", this.paginationConfig.total);
        return data.contractor;
      },
    },
  },
})
export default class Breadcrumbs extends Vue {
    @Prop({ type: Object, required: false }) readonly currentUser?: User;

  numberOfContractorsWithOutLocation = 0;
  contractors: Contractor[] | undefined = [];

  currentRoute: string = "";
  breadCrumbClasses: string = "";
  isStyled: boolean = false;
  isCurrentRoot: boolean = false;

 get isResourcesPage(): boolean {
    const isNewPath =
      this.$route.path.includes("/company_database");
    return isNewPath;
  }

 get isProjectsPage(): string {
    const isNewPath =
      this.$route.path.includes("/clients_visit");
    return isNewPath ? "items-center" : "items-baseline";
  }

  get listStyles(): Object {
    return {
      "flex-row h-12 sm:h-unset flex pt-3 sm:pt-8": true,
      // "pt-8" : !this.isResourcesPage,
      //  "pb-4" : this.isResourcesPage,
      "mb-3 flex py-4 border-primary-color border-solid border-b-1": Boolean(
        this.breadcrumbs[0].icon
      ),
    };
  }


  get isBreadcrumbsExist(): boolean {
    return this.breadcrumbs.length > 0;
  }

  get customBreadcrumbTitle(): string {
    const title = this.$route.query?.breadcrumb_title;
    if (typeof title !== "string") {
      return "";
    }

    return title;
  }

  get breadcrumbs(): Partial<Breadcrumb>[] {
    if (this.customBreadcrumbTitle.length === 0) {
      return this.routeBreadcrumbs;
    }
    return [
      ...this.routeBreadcrumbs,
      {
        title: this.customBreadcrumbTitle,
      },
    ];
  }
  isManagersPage: boolean = false;


    defaultClasses(){
        const routecrumb = this.$route?.meta?.breadcrumb
        this.breadCrumbClasses = '';
        this.isStyled = false;
              if(routecrumb?.classes ){

            this.breadCrumbClasses = typeof routecrumb?.classes !== 'string' ? routecrumb.classes(this.currentUser) :routecrumb?.classes

          }
              if(routecrumb?.isStyled ){

            this.isStyled = typeof routecrumb?.isStyled !== 'boolean' ? routecrumb.isStyled(this.currentUser) :routecrumb?.isStyled

          }
    }
  get routeBreadcrumbs(): Breadcrumb[] {
      this.defaultClasses()
    return this.$route.matched
      .map((match, index) => {
        const originalBreadcrumb = match.meta.breadcrumb;

        if (!originalBreadcrumb || !originalBreadcrumb.title) {
          return;
        }

      // Create a copy to avoid mutating the original route meta
      const breadcrumb = { ...originalBreadcrumb };

      if(typeof breadcrumb?.title !== 'string'){

        breadcrumb.title = breadcrumb.title(this.currentUser)
      }
      if(breadcrumb?.routeName && typeof breadcrumb?.routeName !== 'string'){

        breadcrumb.routeName = breadcrumb.routeName(this.currentUser)
      }
      if(breadcrumb?.classes && typeof breadcrumb?.classes !== 'string'){

        breadcrumb.classes = breadcrumb.classes(this.currentUser)

      }
      if(breadcrumb?.isStyled && typeof breadcrumb?.isStyled !== 'boolean'){

        breadcrumb.isStyled = breadcrumb.isStyled(this.currentUser)
      }

      // Dynamically update Clients & Visits breadcrumb based on section
      if (breadcrumb.title === " Clients & Visits ") {
        const currentPath = this.$route.path;
        const isInVisitsSection = currentPath.includes("/all-visits");
        const isInClientsSection = currentPath.includes("/all-clients");

        if (isInVisitsSection) {
          breadcrumb.title = "Visits";
          breadcrumb.routeName = "empty_visits_tab";
          breadcrumb.routeQuery = { page: "1", limit: "50" };
        } else if (isInClientsSection) {
          breadcrumb.title = "Clients";
          breadcrumb.routeName = "all_active_clients";
        }
      }

        return breadcrumb;
      })
      .filter(Boolean);
  }

  isLinkShown(index: number): boolean {
    return index !== this.breadcrumbs.length - 1;
  }

  getIconSizeClasses(icon: NavigationIcons): string | undefined {
    const narrowIcons = [NavigationIcons.MARKETPLACE, NavigationIcons.GROUPS];

    if (narrowIcons.includes(icon)) {
      return "h-5 w-6";
    }

    return undefined;
  }

  isCopyButtonShown(index: number, breadcrumb: Breadcrumb): boolean {
    return !this.isLinkShown(index) && Boolean(breadcrumb.copyLink);
  }

  async fetchContractorsTotal() {
    const query = gql`
      query GetContractorsTotal($where: contractor_bool_exp) {
        contractorsNumber: contractor_aggregate(where: $where) {
          aggregate {
            count
          }
        }
      }
    `;

    try {
      const response: ApolloQueryResult<any> = await this.$apollo.query({
        query,
        variables: {
          where: {
            // Specify your 'where' filter if necessary
          },
        },
      });

      this.numberOfContractorsWithOutLocation =
        response.data.contractorsNumber.aggregate.count;
    } catch (error) {}
  }

  created() {
    this.setCurrentRoute();
  }

  mounted() {
    this.$watch("$route", this.setCurrentRoute);
    setTimeout(() => {
      this.fetchContractorsTotal();
    }, 1500);
  }


  setCurrentRoute() {
    this.currentRoute = this.$route.name;
    this.isManagersPage = this.currentRoute === '/managers';
    if (this.currentRoute === "talent_mapping") {
      this.isCurrentRoot = true;
      this.fetchContractorsTotal();
    } else {
      this.isCurrentRoot = false;
      this.fetchContractorsTotal();
    }
  }
}
